import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import paymentApprovalService from "services/lms/PaymentApprovalService";

export const fetchPendingApprovals = createAsyncThunk(
  "paymentApproval/fetchPending",
  async (payload, thunkAPI) => {
    try {
      const response = await paymentApprovalService.getPendingApprovals(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const approvePayments = createAsyncThunk(
  "paymentApproval/approve",
  async (items, thunkAPI) => {
    try {
      const response = await paymentApprovalService.approvePayments(items);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const rejectPayments = createAsyncThunk(
  "paymentApproval/reject",
  async (items, thunkAPI) => {
    try {
      const response = await paymentApprovalService.rejectPayments(items);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  data: [],
  totalCount: 0,
  isLoading: false,
  isSuccess: false,
  isError: false,
  message: "",
};

const paymentApprovalSlice = createSlice({
  name: "paymentApproval",
  initialState,
  reducers: {
    resetApprovalState: (state) => {
      state.isSuccess = false;
      state.isError = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPendingApprovals.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(fetchPendingApprovals.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data || [];
        state.totalCount = action.payload?.count || 0;
      })
      .addCase(fetchPendingApprovals.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })

      .addCase(approvePayments.pending, (state) => { state.isLoading = true; })
      .addCase(approvePayments.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload?.message || "Pembayaran berhasil di-approve.";
      })
      .addCase(approvePayments.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload?.Message || action.payload?.message || "Gagal melakukan approval.";
      })

      .addCase(rejectPayments.pending, (state) => { state.isLoading = true; })
      .addCase(rejectPayments.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload?.message || "Pembayaran berhasil di-reject.";
      })
      .addCase(rejectPayments.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload?.Message || action.payload?.message || "Gagal melakukan reject.";
      });
  },
});

export const { resetApprovalState } = paymentApprovalSlice.actions;
export default paymentApprovalSlice.reducer;
